module.exports = [{"code":0,"name":"无"},{"code":1,"name":"进"},{"code":2,"name":"出"},{"code":9,"name":"其他"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/inOutFlag.json
// module id = ZaCG
// module chunks = 11